import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchDeleteCVCompany } from "./learningAPI";
import swal from 'sweetalert';
export interface DocumentMState {
  deleteCVCompany: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: DocumentMState = {
    deleteCVCompany: [],
  status: "idle",
};

export const GetDeleteCVCompany = createAsyncThunk(
  "DeleteCVCompany/fetchDeleteCVCompany",
  async (data:any) => {
    const response = await fetchDeleteCVCompany(data);
    return response;
  }
);

export const DeleteCVCompanySlice = createSlice({
  name: "DeleteCVCompany",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDeleteCVCompany.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetDeleteCVCompany.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetDeleteCVCompany.fulfilled, (state, action) => {
        state.status = "idle";
        state.deleteCVCompany = action.payload;
        swal("Record delete success!",  "success");
        //window.location.reload();
      });
  },
});

export const {} = DeleteCVCompanySlice.actions;

export const selectDeleteCVCompany = (state: RootState) => {
  return state.DeleteCVCompany.deleteCVCompany;
};

export default DeleteCVCompanySlice.reducer;
